import { Select } from "antd";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
const { Option } = Select;


interface Props {
    data: any
    value: string;
    stopEditing: () => void;
    onChange?: (value: string) => void; // Optional onChange callback
    params: any;
    options: any[]
}

interface MoodRef {
    getValue: () => string;
}

const AGSelect = forwardRef<MoodRef, Props>((props, ref) => {
    const [value, setValue] = useState<any>(props.value);
    const [editing, setEditing] = useState<boolean>(false);
    const refContainer = useRef<HTMLDivElement>(null);
    const [options, setOptions] = useState(props?.options ?? [])

    useEffect(() => {
        focus();
    }, []);

    useImperativeHandle(ref, () => ({
        getValue() {
            return value;
        },
    }));

    useEffect(() => {
        setOptions(props?.options)
    }, [props?.options])

    const focus = () => {
        window.setTimeout(() => {
            const container = refContainer.current;
            if (container instanceof HTMLElement) {
                container.focus();
            }
        });
    };

    useEffect(() => {
        if (editing) {
            setEditing(false)
            props.stopEditing()
        }
    }, [editing])


    return (
        <div ref={refContainer}>
            <Select
                className={"w-100"}
                defaultOpen={true}
                autoFocus={true}
                value={value}
                allowClear
                onChange={(value: any, obj: any) => {
                    setValue(obj);
                    if (props.onChange) {
                        props.onChange(value);
                    }
                    setEditing(true)
                }}
            >
                {options?.map((option: any, index: any) => (
                    <Option key={index} value={option.id} label={option.name}>
                        {option?.name}
                    </Option>
                ))}

            </Select>
        </div>
    );
});

export default AGSelect;
